@if (isVisible()) {
<div [id]="navLink.id" class="udex-grid udex-mx-auto udex-mb-64">
  <h2 role="heading" class="heading__regular--l text-center udex-mb-24">
    {{ 'productDetails.publisher' | cxTranslate }}
  </h2>

  <div
    class="d-flex col-7 gap-6 flex-column flex-md-row align-items-center align-items-md-start justify-content-center udex-mx-auto">
    @if (hasLogo) {
    <div class="logo udex-p-32 d-flex justify-content-center align-items-center">
      <cx-media [alt]="name" [container]="{url: logo}"></cx-media>
    </div>
    }

    <div>
      <h3 class="heading__regular--s text-center text-md-start udex-mb-4">
        {{name}}
      </h3>

      <udex-link (click)="openPublisherSolutions(name)" (keydown)="openPublisherSolutionsWithKeyboard(name, $event)"
        [attr.data-cy]="'publisher-solutions'" class="d-block text-center text-md-start udex-mb-16" design="Default"
        accessible-role="Link">
        {{ 'productDetails.publisherSolutions' | cxTranslate }}
      </udex-link>

      <div class="udex-mb-16">
        <dcp-limited-text [charLimit]="300" [text]="description"></dcp-limited-text>
      </div>

      <div class="d-flex gap-4 align-items-center">
        <dcp-cta-form [isPublisherSection]="true" class="flex-grow-0">
        </dcp-cta-form>
        @if (website) {
        <udex-link [attr.data-cy]="'publisher-website'" [attr.href]="website" target="_blank" design="Default"
          accessible-role="Link">
          {{ 'productDetails.viewPublisherInformation' | cxTranslate }}
        </udex-link>
        }
      </div>

    </div>
  </div>
</div>
}
